import { useEffect, useState } from "react";
import { IDataTime } from "../../../../../interface";
import moment from "moment";
import telemetryService from "../../../../../modules/telemetry/telemetry.service";
import { IDevice } from "../../../../../modules/device/device.interface";
import {
  functionRole,
  helpCalculateForDemoMonth1112,
  parseQueryString,
  usingKeyVI,
} from "../../../../../helpers";
import { ITelemetry } from "../../../../../modules/telemetry/telemetry.interface";
import { CommonStyles } from "../../../../ui";
import CommonIcons from "../../../../../assets/icons";
import { getDataFilterDate } from "../../../../../helpers/filterDate";
import { LMMN } from "../../../../../constants/Index";
interface IProps {
  detailHistory: IDataTime | undefined;
  detailDevice: IDevice;
  checkSendSMS: boolean;
  toggle: () => void;
  setSms: any;
}
export default function ModalDetailHistory(props: IProps) {
  //! state
  const { detailHistory, detailDevice, checkSendSMS, toggle, setSms } = props;
  const [dataTable, setDataTable] = useState<ITelemetry>();
  const checkUsingKeyVI = usingKeyVI(detailDevice?.id?.id);

  //! function
  useEffect(() => {
    const timeHours = async () => {
      const startTimeOfHour = moment(detailHistory?.timeSeries)
        .startOf("hour")
        .valueOf();
      const endTimeOfHour = moment(detailHistory?.timeSeries)
        .endOf("hour")
        .valueOf();
      const detailStation = await telemetryService.getTimeSeries(
        detailDevice?.id?.entityType,
        detailDevice?.id?.id,
        parseQueryString({
          startTs: startTimeOfHour,
          endTs: endTimeOfHour,
          useStrictDataTypes: true,
          limit: 50000,
          keys: "data",
          orderBy: "ASC",
        })
      );
      setDataTable(detailStation.data);
    };
    timeHours();
  }, []);

  const columns = [
    {
      title: "Thời gian",
      dataIndex: "time",
      key: "time",
      render: (_: any, record: any) => {
        const timeHour = moment(record.ts).format("HH:mm");
        return <p>{timeHour}</p>;
      },
    },
    {
      title: "Lượng mưa tích luỹ /h(mm/h)",
      dataIndex: "Hourly rainfall",
      key: "Hourly rainfall",
      render: (_: any, record: any) => {
        const keyUse = checkUsingKeyVI ? "mua_theo_gio" : "Hourly rainfall";

        return (
          <p>
            {record?.value[keyUse]?.status ? record?.value[keyUse]?.value : "-"}
          </p>
        );
      },
    },
    {
      title: "Tổng lượng mưa từ 0h (mm)",
      dataIndex: "Rainfall on the day",
      key: "Rainfall on the day",
      render: (_: any, record: any) => {
        const keyUse = checkUsingKeyVI
          ? "mua_theo_ngay"
          : "Rainfall on the day";
        return (
          <p>
            {record?.value[keyUse]?.status ? record?.value[keyUse]?.value : "-"}
          </p>
        );
      },
    },
    {
      title: "Mực nước(cm)",
      dataIndex: "waterLevel",
      key: "waterLevel",
      render: (_: any, record: any) => {
        const keyUse = checkUsingKeyVI ? "muc_nuoc" : "Water Main Level";

        const valueUsing = helpCalculateForDemoMonth1112(
          detailDevice.id.id,
          record?.value[keyUse]?.value
        );
        return <p>{record?.value[keyUse]?.status ? valueUsing : "-"}</p>;
      },
    },
    // {
    //   title: "Gửi SMS",
    //   dataIndex: "address",
    //   hidden: checkSendSMS,
    //   key: "sms",
    //   render: (_: any, record: any) => {
    //     const sms: IDataTime = getDataFilterDate(record.ts, record.value);
    //     return (
    //       <CommonStyles.TooltipUI title="Gửi SMS">
    //         <CommonStyles.ButtonUI
    //           ghost
    //           className="flex items-center justify-center"
    //           onClick={() => {
    //             toggle();
    //             setSms(sms);
    //           }}
    //         >
    //           <CommonIcons.SendOutlined className="-rotate-45 -translate-y-0.5" />
    //         </CommonStyles.ButtonUI>
    //       </CommonStyles.TooltipUI>
    //     );
    //   },
    // },
  ];
  const columnsCDRC = [
    {
      title: "Thời gian",
      dataIndex: "time",
      key: "time",
      render: (_: any, record: any) => {
        const specificDateTime = moment(record?.value?.time)?.format("HH:mm");

        const timeHour = moment(record.ts).format("HH:mm");
        return <p>{specificDateTime}</p>;
      },
    },
    {
      title: "Căng kế (cm)",
      dataIndex: "CrackMetter",
      key: "CrackMetter",
      render: (_: any, record: any) => {
        const keyUse = checkUsingKeyVI ? "cang_day" : "CrackMetter";

        return (
          <p>
            {record?.value[keyUse]?.status ? record?.value[keyUse]?.value : "-"}
          </p>
        );
      },
    },
    {
      title: "Gia tốc thời gian thực (gal)",
      dataIndex: "Vector Gal_Max",
      key: "Vector Gal_Max",
      render: (_: any, record: any) => {
        const keyUse = checkUsingKeyVI ? "gia_toc_tuc_thoi" : "Vector Gal_Max";

        return (
          <p>
            {record?.value[keyUse]?.status ? record?.value[keyUse]?.value : "-"}
          </p>
        );
      },
    },
    {
      title: "Cường độ thời gian thực (level)",
      dataIndex: "IntensityMax",
      key: "IntensityMax",
      render: (_: any, record: any) => {
        const keyUse = checkUsingKeyVI ? "cuong_do_tuc_thoi" : "Intensity_Max";

        return (
          <p>
            {record?.value[keyUse]?.status ? record?.value[keyUse]?.value : "-"}
          </p>
        );
      },
    },
    {
      title: "Gia tốc gần nhất (gal)",
      dataIndex: "Last Gal_Max",
      key: "Last Gal_Max",
      render: (_: any, record: any) => {
        const keyUse = checkUsingKeyVI ? "gia_toc_gan_nhat" : "Last Gal_Max";

        return (
          <p>
            {record?.value[keyUse]?.status ? record?.value[keyUse]?.value : "-"}
          </p>
        );
      },
    },

    // {
    //   title: "Gửi SMS",
    //   dataIndex: "address",
    //   hidden: checkSendSMS,
    //   key: "sms",
    //   render: (_: any, record: any) => {
    //     const sms: IDataTime = getDataFilterDate(record.ts, record.value);
    //     return (
    //       <CommonStyles.TooltipUI title="Gửi SMS">
    //         <CommonStyles.ButtonUI
    //           ghost
    //           className="flex items-center justify-center"
    //           onClick={() => {
    //             toggle();
    //             setSms(sms);
    //           }}
    //         >
    //           <CommonIcons.SendOutlined className="-rotate-45 -translate-y-0.5" />
    //         </CommonStyles.ButtonUI>
    //       </CommonStyles.TooltipUI>
    //     );
    //   },
    // },
  ];
  //! render
  return (
    <CommonStyles.TableUI
      dataSource={dataTable?.data}
      columns={detailDevice?.type === LMMN ? columns : columnsCDRC ?? []}
      scroll={{
        y: 700,
        x: 1000,
      }}
      hasPagination
    />
  );
}
